import * as types from "./mutation-types";

export default {
  [types.SET_STUDY_ID](state, studyId) {
    state.currentStudyId = studyId;
  },

  [types.SET_COMPLETION](state, completion) {
    state.completion = completion;
  },

  [types.SET_COMPLETION_PARTICIPANT](state, completionParticipant) {
    state.completionParticipant = completionParticipant;
  },

  [types.SET_SITE_LIST_IN_PARTICIPANTS](state, siteListInParticipants) {
    state.siteListInParticipants = siteListInParticipants;
  },

  [types.SET_ECONSENT_RAW_DATA](state, eConsentRawData) {
    state.eConsentRawData = eConsentRawData;
  },

  [types.SET_ECONSET_DISPOSITION_DATA](state, eConsentDispositionData) {
    state.eConsentDispositionData = eConsentDispositionData;
  },

  [types.SET_CONSENT_BLOCKS](state, consentBlocks) {
    state.consentBlocks = consentBlocks;
  },



  [types.SET_COUNTRIES](state, countries) {
    state.countryList = countries
  },
  [types.SET_SITES](state, sites) {
    state.allSitesList = sites
  },
  [types.SET_COUNTRY_SELECTED](state, selectedCountries) {
    state.countrySelected = [...selectedCountries]
  },
  [types.SET_SITES_SELECTED](state, selectedSites) {
    state.sitesSelected = [...selectedSites]
  },
  [types.SET_FILTER_FROM_DATE](state, fromDate) {
    state.fromDate = fromDate
  },
  [types.SET_FILTER_TO_DATE](state, toDate) {
    state.toDate = toDate
  },
  [types.SET_IGNORE_CACHE](state, ignoreCache) {
    state.ignoreCache = ignoreCache
  },
  [types.SET_PARTICIPANTS_SELECTED](state, participantsSelected) {
      state.participantsSelected = [...participantsSelected]
  },
  [types.SET_SPECIFIC_SITE_ID](state, specificSiteId) {
    state.specificSiteId = [...specificSiteId]
  }
}